/** Fields the route owner is read from; ids may arrive as bigint or string. */
type Owned = { ownerOrganizationId?: bigint } | undefined;

/** The route's owner: the shift's division, else the truck's, else the active company; none if nothing is known. */
export const routeOwnerOf = (
  shift: Owned,
  truck: Owned,
  activeCompanyId: string | number | null | undefined,
): bigint | undefined =>
  shift?.ownerOrganizationId ||
  truck?.ownerOrganizationId ||
  (activeCompanyId ? BigInt(activeCompanyId) : undefined);
